import { createContext, useContext, useEffect, useState } from 'react';

interface DarkModeContextValue {
  dark: boolean;
  setDark: (v: boolean) => void;
}

const DarkModeContext = createContext<DarkModeContextValue>({ dark: false, setDark: () => {} });

export function DarkModeProvider({ children }: { children: React.ReactNode }) {
  const [dark, setDark] = useState<boolean>(() => localStorage.getItem('citizen-theme') === 'dark');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    localStorage.setItem('citizen-theme', dark ? 'dark' : 'light');
  }, [dark]);

  return <DarkModeContext.Provider value={{ dark, setDark }}>{children}</DarkModeContext.Provider>;
}

export const useDarkMode = () => useContext(DarkModeContext);
